import state from './moduleReservaState'
import mutations from './moduleReservaMutations'
import actions from './moduleReservaActions'
import getters from './moduleReservaGetters'

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
